import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/main.scss";
import "@spsm/designbiblioteket/core.js";

import { createApp } from "vue";
import { createPinia } from "pinia";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import { createRouter, createWebHistory } from "vue-router";
import { appRoutes } from "./routes";
import { setupInterceptorsTo } from "@/helper/interceptor";

async function main() {
  if (process.env.NODE_ENV === "development") {
    const { worker } = await import("./mocks/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
  }

  //get the initialized props
  const element = "#app";
  const container = document.querySelector(element);
  const data = container?.getAttribute("data-settings");
  let parsedData = {};
  if (data) {
    container?.removeAttribute("data-settings");
    parsedData = JSON.parse(data);
  }
  
  axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
  setupInterceptorsTo(axios);
  const pinia = createPinia();
  const app = createApp(App, { settings: parsedData });
  app.use(pinia);
  app.use(VueAxios, axios);
  //init routing
  const router = createRouter({
    history: createWebHistory(),
    routes: appRoutes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      
      return { top: 0 };
    }
  });
  app.use(router);
  app.mount("#app");
}

main();
